<template>
  <div class="pd1-file">
    客户资料
    <div>
      <van-uploader
        v-model="serviceList"
        @delete="deleteImg"
        @click-preview="clickPreview"
        :deletable="false"
        :preview-full-image="false"
        :preview-options="{
          closeable: true,
        }"
      >
        <div></div>
      </van-uploader>

    </div>
    <!-- <div class="pd1-file-image">
      <div
        class="pd1-file-image-item"
        v-for="(item, index) in serviceList"
        :key="index"
      >
        <el-image
          style="width: 100px; height: 100px"
          :src="item.url"
          :preview-src-list="serviceList.map(item => item.url)"
        >
        </el-image>
      </div>
    </div> -->

    <el-upload
      class="upload-demo"
      action=""
      :auto-upload="false"
      :show-file-list="false"
      :http-request="() => {}"
      :on-change="onFileChanged"
      multiple
      :file-list="fileList"
    >
      <el-button
        size="mini"
        type="primary"
      >追加附件</el-button>
    </el-upload>
    <image-viewer
      :z-index="zIndex"
      :initial-index="imageIndex"
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="serviceList.map(item => item.url)"
    />

  </div>
</template>

<script>
import { ImagePreview } from "vant";
import pd1Service from "@/apis/pd1/index.js";
import systemService from "@/apis/system/index.js";
import enums from "@/views/pd1/mixins/enums";
import ImageViewer from "element-ui/packages/image/src/image-viewer.vue";

import { Message } from "element-ui";

export default {
  data() {
    return {
      serviceList: [],
      fileList: [],
      zIndex: 2000,
      imageIndex: 0,
      showViewer: false,
    };
  },
  components: {
      ImageViewer
    },
  mixins: [enums],

  created() {
    this.getFileRecord();
    // setTimeout(() => {
    //   this.showViewer = true;
    // }, 3000);
  },
  methods: {
    clickPreview(item) {
      this.imageIndex = item.index
      console.log(item);
      this.showViewer = true;
    },
    deleteImg(item) {
      const params = {
        file_id: item.file_id,
      };
      pd1Service.fileRemove(params).then((res) => {
        console.log(res);
        this.getFileRecord();
      });
      console.log(item);
    },
    getFileRecord() {
      const query = this.$route.query;
      const params = {
        service_id: query.service_id,
        service_type: query.service_type,
      };
      pd1Service.fileRecord(params).then((res) => {
        res.forEach((item, index) => {
          item.index = index
          item.deletable = true;
          item.url = item.file_path;
        });
        this.serviceList = res;
        console.log(res);
      });
    },
    onFileChanged(file, fileList) {
      const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
      const routeQuery = this.$route.query;
      if (!allowedExtensions.exec(file.name)) {
        Message.error("只能上传图片格式!");
        return;
      }
      this.$nextTick(() => {
        file.status = "uploading";
      });
      this.fileList = fileList;
      const formData = new FormData();
      formData.append("file", file.raw);
      const query = {
        file_type: "pd1",
        file_name: file.name,
        file_ext: file.name.split(".").pop(),
        file_size: file.size,
      };

      const onUploadProgress = (progressEvent) => {
        const percentage =
          (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
        file.percentage = percentage;
        this.$forceUpdate();
      };
      const loading = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      systemService
        .upload(formData, query, onUploadProgress)
        .then((res, url) => {
          file.file_id = res;
          console.log(url);
          const params = {
            service_type: routeQuery.service_type,
            service_id: routeQuery.service_id,
            service_expert_type: routeQuery.service_expert_type,
            file_list: [
              {
                file_path: res.url,
                file_name: file.name,
                file_ext: file.name.split(".").pop(),
                file_size: file.size,
              },
            ],
          };
          pd1Service
            .fileUpload(params)
            .then(() => {
              loading.close();
              Message({
                message: "附件添加成功",
                type: "success",
              });
              this.getFileRecord();
            })
            .catch(() => {
              loading.close();
              Message({
                message: "附件添加失败",
                type: "error",
              });
            });
        });
    },

    previewImage(url) {
      ImagePreview([url]);
    },
    closeViewer() {
      this.showViewer = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.pd1-file {
  padding: 0 20px;
}
.pd1-file-image {
  display: flex;
  flex-wrap: wrap;
}
</style>